// export const BASE_URL_V1 = "https://api.primetime-tournaments.com/" // todo:
export const BASE_URL_V2 = "https://dummyjson.com";

export const WEB_ROUTES = {
  ACCOUNT: "/account",
  DASHBOARD: "/dashboard",
  USER_MANAGEMENT: "/user-management",
  CATEGORY_MANAGEMENT: "/category-management",
  ORDER_MANAGEMENT: "/order-management",
  ORDER_DETAILS: "/order-details",
  PRODUCT_MANAGEMENT: "/product-management",
  FAQ_MANAGEMENT: "/faq-management",
  REWARD_MANAGEMENT: "/reward-management",
  LEVELS_MANAGEMENT: "/levels-management",
  PACKAGES_MANAGEMENT: "/packages-management",

  BADGES_MANAGEMENT: "/badges-management",
  POLL_RULES_MANAGEMENT: "/poll-rules-management",
  POLLS_MANAGEMENT: "/polls-management",
  SUGGESTION_POLLS_MANAGEMENT: "/suggestion-polls-management",
  BANNERS_MANAGEMENT: "/banners-management",
  ADVERTISEMENT_MANAGEMENT: "/advertisement-management",
  TXN_MANAGEMENT: "/txn-management",
  SUPPORT: "/support-chat",

  // GAME_MANAGEMENT: "/game-management",
  // GAME_CATEGORIES_MANAGEMENT: "/game-categories-management",
  // GAME_TEAMS_MANAGEMENT: "/game-teams-management",
  // GAME_QUESTION_MANAGEMENT: "/game-question-management",

  SEND_NOTIFICATION: "/send-notification",
  SETTING: "/settings",
  PAGE_MANAGEMENT: "/page-management",
};

export const QUESTION_TYPE = {
  EASY: 10,
  MEDIUM: 30,
  HARD: 50,
};

export const GAME_TYPE = {
  SOLO: 10,
  TEAM: 20,
};

export const BREAKPOINTS = {
  MOBILE: 991,
};
export const apiUrl = {
  auth: "auth",
  api: "api",
  role: "admin",
  user: "user",
  login: "login",
  forgotPass: "forgot-password",
  changePass: "change-password",

  // tournament
  tournament: "tournament",
  livetournament: "tournament/live",
  scheduletournament: "tournament/schedule",
  ageGroup: "age-group",
  refund: "refund",
  startmatch: "match/start",
  endmatch: "match/end",
};

// DATA ->
// DUMMY
export const sportsStateList = [
  { value: 1, label: "State 1" },
  { value: 2, label: "State 2" },
  { value: 3, label: "State 3" },
];

export const sportsTypeList = [{ value: "Baseball", label: "Baseball" }];

export const formateTTime = (dateStr) => {
  const date = new Date(dateStr);
  const options = { hour: "numeric", minute: "2-digit", hour12: true };
  const timeFormatted = date.toLocaleString("en-US", options);
  return timeFormatted;
};

export const formatedDate = (dateStr) => {
  const date = new Date(dateStr);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    // hour: 'numeric',
    // minute: '2-digit',
    // hour12: true
  };
  const dateFormatted = date.toLocaleString("en-US", options);
  return dateFormatted;
};

export const chartData = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Yearly",
      data: [],
      fill: true,
      backgroundColor: "rgba(75,192,192,0.2)",
      borderColor: "rgba(75,192,192,1)",
    },
  ],
};
export const legends = ["Weekdays", "Normal Days"]; // Your custom labels

export const chartOptions = {
  plugins: {
    legend: {
      position: "top",
      display: false,
      align: "end",
      labels: {
        usePointStyle: true,
        // generateLabels: function (chart) {
        //   if (!chart || !chart.data || !chart.data.datasets) return [];
        //   return chart.data.datasets.map((dataset, index) => ({
        //     text: `${legends[index]}`,
        //     fillStyle: dataset.backgroundColor,
        //     hidden: !chart.isDatasetVisible(index),
        //     lineCap: dataset.borderCapStyle,
        //     lineDash: dataset.borderDash,
        //     lineDashOffset: dataset.borderDashOffset,
        //     lineJoin: dataset.borderJoinStyle,
        //     strokeStyle: dataset.borderColor,
        //     dataset: dataset,
        //     index: index,
        //   }));
        // },
      },
    },
    title: {
      display: true,
      text: "Monthly Earnings",
      color: "#158E10",
      font: {
        size: 20,
        weight: "bold",
        family: "Arial, sans-serif",
      },
      padding: {
        top: 10,
        bottom: 20,
      },
      align: "start",
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Month", // Label for the x-axis
      },
    },
    y: {
      title: {
        display: true,
        text: "Earning", // Label for the x-axis
      },

      beginAtZero: true,
      ticks: {
        maxTicksLimit: 6,
        callback: function (value) {
          if (value >= 1000) {
            return `${(value / 1000).toFixed(0)}k`;
          }
          return value;
        },
      },
    },
  },
  animation: false, // Disable animations to prevent errors
};
export const chartOptionsOrder = {
  plugins: {
    legend: {
      position: "top",
      display: false,
      align: "end",
      labels: {
        usePointStyle: true,
        // generateLabels: function (chart) {
        //   if (!chart || !chart.data || !chart.data.datasets) return [];
        //   return chart.data.datasets.map((dataset, index) => ({
        //     text: `${legends[index]}`,
        //     fillStyle: dataset.backgroundColor,
        //     hidden: !chart.isDatasetVisible(index),
        //     lineCap: dataset.borderCapStyle,
        //     lineDash: dataset.borderDash,
        //     lineDashOffset: dataset.borderDashOffset,
        //     lineJoin: dataset.borderJoinStyle,
        //     strokeStyle: dataset.borderColor,
        //     dataset: dataset,
        //     index: index,
        //   }));
        // },
      },
    },
    title: {
      display: true,
      text: "Total Orders",
      color: "#0f0f0f",
      font: {
        size: 20,
        weight: "bold",
        family: "Arial, sans-serif",
      },
      padding: {
        top: 10,
        bottom: 20,
      },
      align: "start",
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Month", // Label for the x-axis
      },
    },
    y: {
      title: {
        display: true,
        text: "Order", // Label for the x-axis
      },

      beginAtZero: true,
      ticks: {
        maxTicksLimit: 6,
        callback: function (value) {
          if (value >= 1000) {
            return `${(value / 1000).toFixed(0)}k`;
          }
          return value;
        },
      },
    },
  },
  animation: false, // Disable animations to prevent errors
};
